export default __webpack_public_path__ + "static/media/meet_people_intro.de7d6cb8.webp";